import { apiClient } from "../../api/apiClient";

export const fetchPropertyManagementByIdAsync = (id) =>
  apiClient().get(`/propertymanagements/${id}`);
